var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import FormGroup from "../Components/FormGroup.vue";
import FormCheckboxGroup from "bootstrap-vue/es/components/form-checkbox/form-checkbox-group";
var Experience = /** @class */ (function (_super) {
    __extends(Experience, _super);
    function Experience() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.localStartYear = _this.startYear || null;
        _this.localGradeLevels = _this.gradeLevels;
        _this.localGradeLevelOther = _this.gradeLevelOther || null;
        return _this;
    }
    Experience.prototype.onStartYearChanged = function (val) { if (typeof val === "string")
        this.localStartYear = null;
    else
        this.$emit("update:startYear", val); };
    Experience.prototype.onGradeLevelsChanged = function (val) { this.$emit("update:gradeLevels", val); };
    Experience.prototype.onGradeLevelOtherChanged = function (val) { this.$emit("update:gradeLevelOther", val); };
    __decorate([
        Prop({ type: Object, required: true })
    ], Experience.prototype, "metadata", void 0);
    __decorate([
        Prop({ type: Object, required: true })
    ], Experience.prototype, "$v", void 0);
    __decorate([
        Prop({ type: Number })
    ], Experience.prototype, "startYear", void 0);
    __decorate([
        Watch("localStartYear")
    ], Experience.prototype, "onStartYearChanged", null);
    __decorate([
        Prop({ type: String, default: "startYear" })
    ], Experience.prototype, "mStartYear", void 0);
    __decorate([
        Prop({ type: String, default: "startYear" })
    ], Experience.prototype, "$vStartYear", void 0);
    __decorate([
        Prop({ type: Array, default: [] })
    ], Experience.prototype, "gradeLevels", void 0);
    __decorate([
        Watch("localGradeLevels")
    ], Experience.prototype, "onGradeLevelsChanged", null);
    __decorate([
        Prop({ type: String, default: "gradeLevels" })
    ], Experience.prototype, "mGradeLevels", void 0);
    __decorate([
        Prop({ type: String, default: "gradeLevels" })
    ], Experience.prototype, "$vGradeLevels", void 0);
    __decorate([
        Prop({ type: String })
    ], Experience.prototype, "gradeLevelOther", void 0);
    __decorate([
        Watch("localGradeLevelOther")
    ], Experience.prototype, "onGradeLevelOtherChanged", null);
    __decorate([
        Prop({ type: String, default: "gradeLevelOther" })
    ], Experience.prototype, "mGradeLevelOther", void 0);
    __decorate([
        Prop({ type: String, default: "gradeLevelOther" })
    ], Experience.prototype, "$vGradeLevelOther", void 0);
    Experience = __decorate([
        Component({
            name: "Experience",
            components: {
                FormGroup: FormGroup,
                FormCheckboxGroup: FormCheckboxGroup
            }
        })
    ], Experience);
    return Experience;
}(Vue));
export default Experience;
;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/Account/Experience.vue
// module id = 876
// module chunks = 6